// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__33p8y","white":"Card_white__4shqa"};